import React from 'react';
import MaterialLayout from './components/Layout/MaterialLayout';
import EmploymentPageHrInspection from './components/EmploymentPage/EmploymentPageHrInspection';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Link,
  useParams,
  useRouteMatch,
  Navigate,
  Outlet,
} from 'react-router-dom';

//from NinjaMain
function Stepper4HrInspect() {
  const { idCard } = useParams();
  // console.log('----Stepper4HrInspect---' + idCard);
  //https://medium.com/@nphivu414/build-a-multi-step-form-with-react-hooks-formik-yup-and-materialui-fa4f73545598
  return (
    <div>
      <MaterialLayout>
        {/* copy มาจาก EmploymentPage.jsx */}
        {/* แก้คำ เจ้าหน้าที่ตรวจสอบข้อมูล */}
        {/* props idCard */}
        {/* ปุ่ม back */}
        <EmploymentPageHrInspection idCard={idCard} />
      </MaterialLayout>
    </div>
  );
}

export default Stepper4HrInspect;
